<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{ grayMode: grayActive }"
  >
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <div
        class="d2-theme-header header-gradient"
        :style="{
          opacity: this.searchActive ? 0.5 : 1,
        }"
        flex-box="0"
        flex
      >
        <div
          class="logo-group"
          :style="{ width: asideCollapse ? asideWidthCollapse : asideWidth }"
          style="display:flex; align-items:center;justify-content: center;"
          flex-box="0"
        >
          <img
            v-if="asideCollapse"
            :src="`${this.baseUrl}images/common/sigoran_logo.png`"
            style="width:40px;height:14px;"
          />
          <img
            v-else
            :src="`${this.baseUrl}images/common/login_logo.png`"
            style="width:109px;height:40px;"
          />
        </div>
        <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">
          <d2-icon name="bars" />
        </div>
        <d2-menu-header flex-box="1" />
        <!-- 顶栏右侧 -->
        <div class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <!-- <d2-header-search @click="handleSearchClick" /> -->
          <!-- <d2-header-log/>
          <d2-header-fullscreen/>
          <help-center/>
          <d2-header-theme/>
          <d2-header-size/> -->
          <div class="matchtex" >
            <i class="iconfont iconoperate_match_game" ></i>
            <el-tooltip :disabled="(getMatchStatus.matchName&&getMatchStatus.matchName.length<16)" :content="getMatchStatus.matchName" placement="bottom">
              <p class="ellipsis">{{getMatchStatus.matchName}}</p>
            </el-tooltip>
            
          </div>
          <el-tooltip effect="dark" content="通知列表" placement="bottom" >
            <template>
              <el-popover popper-class="popoverClass" placement="top-start"  width="300" trigger="click" v-model="visible">
                  <div style="padding: 12px 17px;display: flex;justify-content: space-between;">
                  <div><el-badge  :is-dot='num!=0' class="item">通知列表</el-badge></div>
                  <div style="font-size: 16px;cursor: pointer;" @click="visible = false"><i class="el-icon-close"></i></div>
                </div>
                <div style="border-bottom: 1px solid #dcdfe6"></div>
                <div class="innerbox" >
                <div style="padding: 0px 17px;width: 240px" v-infinite-scroll="loadMore"  infinite-scroll-disabled="loading" infinite-scroll-distance="10" immediate-check="false">
                  <div  v-for="(item, index) in newList" :key="index">
                    <div style="margin: 20px 0 10px 0;color: #a2a5b3;font-weight: 400;">
                      {{ item.scanningTime }}
                    </div>
                    <div
                      style="margin-bottom: 10px;display: flex;"
                      v-for="(itemtwo, indextwo) in item.contents"
                      :key="indextwo"
                    >
                     <div> <div class="isreaddiv" :class="itemtwo.isRead=='1'?'tabs-active':''"></div></div>
                      <div @click="oncpclick(itemtwo.bizType,itemtwo.id)">
                        <span class="chuanpspan" :class="itemtwo.isRead=='1'?'tabs-active':''" >{{ itemtwo.content }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
                <!-- <div v-if="!endFlag">loading....</div> -->
                <div  style="text-align: right; margin: 10px 10px 10px 10px">
                  <el-button style="opacity: 0.5" v-if="num==0" type="primary" >全部已读</el-button>
                   <el-button  v-else type="primary" @click="onsee">一键已读</el-button>
                  <el-button @click="visible = false">取消</el-button>
                </div>
                <el-button
                  class="d2-ml-0 d2-mr btn-text can-hover"
                  type="text"
                  slot="reference"
                >
                  <div class="badegdiv">
                    <el-badge :value="numtwo" class="item">
                      <!-- <i class="iconfont iconwodewangpan_default" style="font-size:16px"></i> -->
                      <img src="@/assets/image/nav_remind_icon.svg" />
                    </el-badge>
                  </div>
                </el-button>
              </el-popover>
            </template>
          </el-tooltip>
          <el-tooltip effect="dark" content="我的网盘" placement="bottom">
            <el-button
              class="d2-ml-0 d2-mr btn-text can-hover"
              type="text"
              @click="goto"
            >
              <i
                class="iconfont iconoperate_nav_netdisk1"
                style="font-size: 20px"
              ></i>
            </el-button>
          </el-tooltip>
          <d2-header-user />
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1,
          }"
        >
          <d2-menu-side />
        </div>
        <!-- 主体 -->
        <div class="d2-theme-container-main" flex-box="1" flex>
          <!-- 搜索 -->
          <transition name="fade-scale">
            <div v-if="searchActive" class="d2-theme-container-main-layer" flex>
              <d2-panel-search ref="panelSearch" @close="searchPanelClose" />
            </div>
          </transition>
          <!-- 内容 -->
          <transition name="fade-scale">
            <div
              v-if="!searchActive"
              class="d2-theme-container-main-layer"
              flex="dir:top"
            >
              <!-- 面包屑 -->
              <!-- <div class="d2-theme-container-main-header" style="padding-left:20px" flex-box="0">
                <bread-crumb/>
              </div> -->
              <!-- tab -->
              <div class="d2-theme-container-main-header" flex-box="0">
                <d2-tabs  v-if="getMatchStatus.matchId"/>
              </div>
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <d2-container>
                  <div class="page-base">
                    <transition :name="transitionActive ? 'fade-transverse' : ''">
                      <keep-alive :include="keepAlive">
                        <!-- <router-view /> -->
                        <router-view :key="$route.fullPath"/>
                      </keep-alive>
                    </transition>
                  </div>
                </d2-container>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IMG_URL } from '@/config'
import d2MenuSide from './components/menu-side'
import infiniteScroll from 'vue-infinite-scroll'
import d2MenuHeader from './components/menu-header'
import d2Tabs from './components/tabs'
// import d2HeaderFullscreen from './components/header-fullscreen'
import d2HeaderSearch from './components/header-search'
// import d2HeaderSize from './components/header-size'
import d2HeaderTheme from './components/header-theme'
import helpCenter from './components/help-center'
import d2HeaderUser from './components/header-user'
// import d2HeaderLog from './components/header-log'
import breadCrumb from './components/bread-crumb'
import { mapState, mapGetters, mapActions } from 'vuex'
import mixinSearch from './mixins/search'
import { getremind, getonekeyRead, getonekeyReadid, getMsgsCount } from '@/api/sagerui/equipment'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import store from '@/store'
export default {
  name: 'd2-layout-header-aside',
  directives: { infiniteScroll },
  mixins: [mixinSearch],
  components: {
    d2MenuSide,
    d2MenuHeader,
    d2Tabs,
    // d2HeaderFullscreen,
    d2HeaderSearch,
    // d2HeaderSize,
    d2HeaderTheme,
    d2HeaderUser,
    // d2HeaderLog,
    breadCrumb,
    helpCenter
  },
  data() {
    return {
      baseUrl:IMG_URL,
      loading: false,
      visible: false,
      numtwo: null,
      notificationList: '', // 通知列表
      num: '',
      list: [],
      params: {
        page: 1, // 分页器当前页
        limit: 6 // 每页条数
      },
      endFlag: false,
      newList: [],
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px'
    }
  },
  computed: {
    ...mapState('d2admin', {
      keepAlive: (state) => state.page.keepAlive,
      grayActive: (state) => state.gray.active,
      transitionActive: (state) => state.transition.active,
      asideCollapse: (state) => state.menu.asideCollapse
    }),
    ...mapGetters('d2admin', {
      themeActiveSetting: 'theme/activeSetting'
    }),
    ...mapGetters('d2admin/user', [
      'getMatchStatus'
    ]),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...(this.themeActiveSetting.backgroundImage
          ? {
            backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
          }
          : {})
      }
    }
  },
  mounted() {
    // this.getinfo(6)
    // this.onMsgsCoun()
    // this.onwebscoket()
  },
  beforeDestroy() {
    this.notificationList.disconnect()
  },
  methods: {
    ...mapActions('d2admin/menu', ['asideCollapseToggle']),
    /**
     * 接收点击切换侧边栏的按钮
     */
    onMsgsCoun() {
      let that = this
      getMsgsCount()
        .then((res) => {
          if (res.data == '0') {
            that.numtwo = ''
          } else {
            that.numtwo = res.data
          }
        })
    },
    goto(){
      if(!this.getMatchStatus.matchId){
        this.$message.warning('请先创建赛事')
        return
      }else{
        let routeData = this.$router.resolve({ path: '/scratchDisks' })
        window.open(routeData.href,'_blank')
      }
    },
    onwebscoket() {
      let that = this
      let url = process.env.VUE_APP_WSAPI
      let socket = new SockJS(url)
      that.numtwo = null
      this.notificationList = Stomp.over(socket)
      that.notificationList.connect({ Authorization: '' }, function (frame) {
        that.notificationList.subscribe(`/websocket/topic/messageCount/${store.state.d2admin.user.info.shed.id}`, function (message) {
          let json = JSON.parse(message.body)
          console.log('json', json)
          if (json == 0) {
            that.numtwo = ''
          } else {
            that.numtwo = json
          }

          // that.getinfo(6)
        })
      }, (err) => {
        console.log(err)
      })
    },
    onsee() {
      let that = this
      getonekeyRead(this.params)
        .then((res) => {
          that.numtwo = ''
          // this.getinfo(this.params)
        })
    },
    oncpclick(val, id) {
      if (val == 'SCURRY_SHED') {
        getonekeyReadid({ id: id })
          .then((res) => {
            // this.getinfo(this.params)
          })
        this.$router.push({
          path: 'sagerui/equipment',
          query: {
            type: '4'
          }
        })
      }
    },
    loadMore() {
      // this.getinfo(this.params)
      // debugger
    },
    getinfo(val) {
      this.loading = true// 请求数据的开关
      // const res =  getremind(this.params)
      getremind(this.params)
        .then((res) => {
          if (parseInt(res && res.code) === 0) {
            if (this.params.limit > res.data.totalCount) {
              this.loading = true /* 终止请求 */
              this.endFlag = true
            }
            this.params.limit = this.params.limit + 6
            let list = res.data.list
            this.num = list.filter((item) => item.isRead == '0')
            // 取出日期
            let dateArray = list.map((item) => item.scanningTime)
            // dateArray去重
            dateArray = [...new Set(dateArray)]
            // 根据日期重新做能用的数组
            let newList = []

            dateArray.forEach((item) => {
              newList.push({
                scanningTime: item,
                contents: []
              })
            })

            for (let i = 0; i < list.length; i++) {
              for (let j = 0; j < newList.length; j++) {
                if (list[i].scanningTime == newList[j].scanningTime) {
                  newList[j].contents.push({
                    content: list[i].content,
                    bizType: list[i].bizType,
                    isRead: list[i].isRead,
                    id: list[i].id
                  })
                }
              }
            }
            // console.log(newList, 'newlist')
            // this.loading = false
            this.newList = newList
          } else {
            console.log(res)
          }
        })
        .catch((err) => {
          console.log(err)
        })
      this.loading = false
    },
    handleToggleAside() {
      this.asideCollapseToggle()
    }
  }
}
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';
$color1: #2556C4;
$color2: #477CF4;
.noClick{
  cursor: not-allowed!important;
}
.matchtex{
  color:#ffffff;font-size:16px;
  display: flex;
  align-items: center;
  padding-right: 20px;
  // cursor: pointer;
  .iconfont{
    font-size:22px;margin-right: 4px;
  }
  p{
    max-width: 280px;
  }
}
.ellipsis{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}
  .badegdiv {
  .el-badge__content{
    border:none;
    padding: 3px 9px;
    font-size: 16px;
    border-radius: 15px;
  }
  .el-badge__content.is-fixed {
    transform: translateY(-45%) translateX(80%) scale(0.6);
  }
}
.el-popover  {
  padding: 0px;
  // left: 1500px;
  // z-index: 9999;
}
.layout{
  .el-button--primary {
        opacity: 0.5;
  }
}
.popoverClass{
  // left: 50% !important;
  left:auto !important;
  right: 116px;
}

.el-popper[x-placement^=bottom] .popper__arrow::after {
    top: 1px;
    margin-left: 105px;
    border-top-width: 0;
    border-bottom-color: #FFF;
}
.chuanpspan {
  line-height: 25px;
  cursor: pointer;
}
.chuanpspan.tabs-active{
  opacity: 0.5;
}
.isreaddiv{
  width: 6px;
  height: 6px;
  margin-top: 9px;
  background: rgb(64, 158, 255);
  border-radius: 50%;
}
.isreaddiv.tabs-active{
   opacity: 0.5;
}
.innerbox{
  overflow: auto;
  height:380px
}
.innerbox::-webkit-scrollbar {/*滚动条整体样式*/
            width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 4px;
            scrollbar-arrow-color:red;

        }
        .innerbox::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
            scrollbar-arrow-color:red;
        }
        .innerbox::-webkit-scrollbar-track {/*滚动条里面轨道*/
            // -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            // border-radius: 0;
            // background: rgba(0,0,0,0.1);
        }
.page-base {
  min-width: 1100px;
  padding: 20px;
  min-height: calc(100% - 40px);
  background: #fff;
  box-shadow: 0px 0px 20px 0px rgba(4, 0, 0, 0.1);
  border-radius: 5px;
}
.header-gradient {
  background: -webkit-linear-gradient(
    left,
    $color1,
    $color2
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    right,
    $color1,
    $color2
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    right,
    $color1,
    $color2
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, $color1, $color2); /* 标准的语法 */
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
